import { render, staticRenderFns } from "./VehicleSchedulePage.vue?vue&type=template&id=ded01808&scoped=true&"
import script from "./VehicleSchedulePage.vue?vue&type=script&lang=js&"
export * from "./VehicleSchedulePage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSchedulePage.vue?vue&type=style&index=0&id=ded01808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded01808",
  null
  
)

export default component.exports